<template lang="pug">
  div
    .py-1(v-for="language in allowedLanguages")
      .columns(v-if="getResume(language)")
        .column
          form-group(:label="`Resumo em ${$options.filters.language(language)}`")
            a.text-error.ml-2.c-hand(slot="label-action" @click="removeResume(language)")
              i.fas.fa-trash
            textarea.form-input(@input="event => onInputResume(event, language)" :value="getResume(language).resume")
      .columns(v-else)
        .column Nenhum resumo no idioma: {{ language | language }}
        .columns.col-auto
          a.btn.btn-link.btn-sm.tooltip.tooltip-left(
            :data-tooltip="`Adicionar resumo em ${$options.filters.language(language)}`"
            @click="addResume(language)"
          )
            i.fas.fa-plus
</template>

<script>
export default {
  props: {
    value: { type: Array, required: true },
  },
  computed: {
    allowedLanguages() {
      return ['pt', 'en']
    },
  },
  methods: {
    getResume(language) {
      return this.value.find(resume => resume.language === language)
    },
    addResume(language) {
      this.$emit('input', [...this.value, { resume: '', language }])
    },
    removeResume(language) {
      this.$emit(
        'input',
        this.value.filter(resume => resume.language !== language),
      )
    },
    onInputResume(event, language) {
      const resumes = this.value.map(i => {
        if (i.language !== language) return i
        return { resume: event.target.value, language }
      })
      this.$emit('input', resumes)
    },
  },
}
</script>
